<template>
<v-card>
	<v-card-title
		class="pt-4 pb-0 title"
	>
		Add / edit entity
	</v-card-title>
	<v-container grid-list-sm class="pa-4">

		<v-layout row wrap>

			<v-flex xs10 offset-xs1 class="pb-4 pt-0">
				<v-autocomplete outline label="Elements" multiple v-model="selectedInputs" :items="availableInputs">
				</v-autocomplete>
			</v-flex>

			<v-flex xs12 align-center justify-space-between v-if="selectedInputs.includes('name')">
				<v-text-field
					label="Name"
				></v-text-field>
			</v-flex>

			<v-flex xs12 align-center justify-space-between v-if="selectedInputs.includes('driver')">
				<jm-combobox type="person" v-model="entity.data.driver" label="Driver" multiple>
				</jm-combobox>
			</v-flex>


			<v-flex xs12 align-center justify-space-between v-if="selectedInputs.includes('vehicle')">
				<jm-combobox type="asset" v-model="entity.data.vehicle" label="Vehicle" multiple>
				</jm-combobox>
			</v-flex>

			<v-flex xs12 align-center justify-space-between v-if="selectedInputs.includes('origin')">
				<jm-location v-model="entity.data.origin" label="Origin">
				</jm-location>
			</v-flex>

			<v-flex xs12 align-center justify-space-between v-if="selectedInputs.includes('destination')">
				<jm-location v-model="entity.data.destination" label="Destination">
				</jm-location>
			</v-flex>

			<v-flex xs12 align-center justify-space-between v-if="selectedInputs.includes('departure')">

				<v-container class="pa-0">
					<v-layout row wrap>

						<v-flex xs6 sm12 md3>
							<v-switch
							small
							label="Scheduled Departure"
							v-model="std"
							>
							</v-switch>
						</v-flex>

						<v-flex xs6 sm4 md3>
							<v-radio-group row v-if="std">
								<v-radio label="Local" value="lt"></v-radio>
								<v-radio label="UTC" value="utc"></v-radio>
							</v-radio-group>
						</v-flex>

						<v-flex xs6 sm4 md3>
							<v-menu v-if="std"
							ref="depDateMenu"
							lazy
							v-model="depDateMenu"
							:close-on-content-click="false"
							:return-value.sync="depDate">
								<v-text-field
								slot="activator"
								v-model="depDate"
								label="Date"
								readonly></v-text-field>
								<v-date-picker v-if="depDateMenu"
								v-model="depDate"
								@change="$refs.depDateMenu.save(depDate)">
								</v-date-picker>
							</v-menu>
						</v-flex>

						<v-flex xs6 sm4 md3>
							<v-menu v-if="std"
							ref="depTimeMenu"
							v-model="depTimeMenu"
							:close-on-content-click="false"
							:return-value.sync="depTime">
								<v-text-field
								slot="activator"
								v-model="depTime"
								label="Time"
								readonly></v-text-field>
								<v-time-picker v-if="depTimeMenu"
								format="24hr"
								v-model="depTime"
								@change="$refs.depTimeMenu.save(depTime)">
								</v-time-picker>
							</v-menu>
						</v-flex>

					</v-layout>
				</v-container>
			</v-flex>

			<v-flex xs12 v-if="selectedInputs.includes('email')">
				<v-text-field
					type="email"
					prepend-icon="fa-envelope"
					label="Email"
				></v-text-field>
			</v-flex>

			<v-flex xs12 v-if="selectedInputs.includes('phone')">
				<v-text-field
					type="tel"
					prepend-icon="fa-phone"
					label="(000) 000 - 0000"
					mask="phone"
				></v-text-field>
			</v-flex>

			<v-flex xs12 v-if="selectedInputs.includes('remarks')">
				<v-text-field
					prepend-icon="fa-comment"
					label="Remarks"
				></v-text-field>
			</v-flex>

		</v-layout>
	</v-container>
	<v-card-actions>
		<v-btn flat color="primary">More</v-btn>
		<v-spacer></v-spacer>
		<v-btn flat color="primary" @click="setVisibility(false)">Cancel</v-btn>
		<v-btn flat @click="setVisibility(false)">Save</v-btn>
	</v-card-actions>
</v-card>
</template>

<script>
import JmCombobox from './widgets/InputWidgets/Combobox'
import JmLocation from './widgets/InputWidgets/Location'
import { EntityCollection } from '@/assets/js/JMan/EntityCollection'
import { Entity, Person, Journey } from '@/assets/js/JMan/Entity'

export default {
	name: "JmEdit",

	props: {
		shown: Boolean
	},

	data () {
		return {
			isUpdating: false,
			driver: [],
			items: [],
			search: null,
			entity: new Journey({}, this.$store.state.jman.api),
			availableInputs: [
				{ text: "Name", value: "name", disabled: false },
				{ text: "Driver", value: "driver", disabled: false },
				{ text: "Vehicle", value: "vehicle", disabled: false },
				{ text: "Origin", value: "origin", disabled: true },
				{ text: "Destination", value: "destination", disabled: true },
				{ text: "Departure", value: "departure", disabled: false },
				{ text: "Via", value: "via", disabled: false },
				{ text: "Remarks", value: "remarks", disabled: false }
			],
			selectedInputs: [ "driver", "vehicle", "origin", "destination" ],
			actions: [],
			depTimeMenu: false,
			depTime: null,
			depDateMenu: false,
			depDate: null,
			std: false
		}
	},

	watch: {
		search (value) {
			if (value) {
				this.query(value)
			}
		},

		driver (value, previous) {
			const api = this.$store.state.jman.api;
			if (value.length != previous.length) {
				this.driver = value.map(item => {
					if (typeof item === 'string') {
						item = new Person({data: { name: item }}, api);
					}
					return item;
				});
			}
		}
	},

	computed: {
//		person () {
//			const person = this.$store.state.jman.entities
//				.filter(e => e.type == 2)
//				.map(e => {
//					return {
//						displayName: e.displayName(),
//						id: e.id,
//						thumbnail: e.data.thumbnailUrl || e.data.imageUrl
//					}
//				});
//			return person;
//		}
	},

	methods: {
		query (value) {
			this.isUpdating = true;
			const entities = this.$store.state.jman.entities;
			const fields = `name:%${value}%,handle:%${value}%,email:%${value}%`;
			const items = EntityCollection.filter(entities, {type: 2, fields});
			this.items = items;
			this.isUpdating = false;
		},

		filter (item, queryText, itemText) {
			return item.match(new RegExp(queryText, "i"));
		},

		setVisibility (isVisible) {
			this.$emit("visibilityChange", isVisible);
		}
	},

	components: {
		JmCombobox,
		JmLocation
	}
}

</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Edit.vue